import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../core/services/api.service';
import { AuthService } from '../../../core/services/auth.service';
import { CenterService } from '../../../core/services/center.service';
import { PageTitleService } from '../../../core/services/page-title.service';

type DatePreset = 'today' | 'yesterday' | 'month' | 'custom';

@Component({
  selector: 'app-daily-summary',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './daily-summary.component.html',
  styleUrl: './daily-summary.component.scss',
})
export class DailySummaryComponent implements OnInit {

  isAdmin   = false;
  isManager = false;

  preset: DatePreset = 'today';
  customFrom = '';
  customTo   = '';

  loading = false;
  error   = '';
  loaded  = false;

  summary: any  = null;
  centers: any[] = [];
  runners: any[] = [];

  constructor(
    private api: ApiService,
    private auth: AuthService,
    private centerSvc: CenterService,
    private pageTitle: PageTitleService,
  ) {}

  ngOnInit(): void {
    this.pageTitle.set('Daily Summary', 'Subscriptions and member activity');
    const user = this.auth.getCurrentUser();
    this.isAdmin   = user?.role?.toLowerCase() === 'admin';
    this.isManager = user?.role?.toLowerCase() === 'manager';

    const today = new Date().toISOString().slice(0, 10);
    this.customFrom = today;
    this.customTo   = today;
    this.setPreset('today');
  }

  setPreset(p: DatePreset): void {
    this.preset = p;
    if (p !== 'custom') this.load();
  }

  private activeDates(): { from: string; to: string } | null {
    const pad = (n: number) => String(n).padStart(2, '0');
    const fmt = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const today = new Date();
    if (this.preset === 'today')     { const s = fmt(today); return { from: s, to: s }; }
    if (this.preset === 'yesterday') { const y = new Date(today); y.setDate(y.getDate() - 1); const s = fmt(y); return { from: s, to: s }; }
    if (this.preset === 'month')     { return { from: `${today.getFullYear()}-${pad(today.getMonth() + 1)}-01`, to: fmt(today) }; }
    if (this.preset === 'custom' && this.customFrom && this.customTo) return { from: this.customFrom, to: this.customTo };
    return null;
  }

  load(): void {
    const dates = this.activeDates();
    if (!dates) return;

    const centerId = this.isAdmin ? 'all' : (this.centerSvc.selectedCenter?._id || '');
    if (!centerId) { this.error = 'No center assigned to this account.'; return; }

    this.loading = true;
    this.error   = '';
    this.loaded  = false;

    this.api.getDailySummary(centerId, dates.from, dates.to).subscribe({
      next: (res: any) => {
        this.summary = res.summary  || null;
        this.centers = res.centers  || [];
        this.runners = res.runners  || [];
        this.loading = false;
        this.loaded  = true;
      },
      error: (err: any) => {
        this.error   = err?.message || 'Failed to load summary.';
        this.loading = false;
      },
    });
  }

  fmt(n: number): string {
    return (n || 0).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
}
